import links from '../links'

// TODO: remove state argument. Just send isLoggedIn, gender
// TODO: Get typed State
export default ({ state, userGenderCookie }: { state: any, userGenderCookie?: Gender }): string => {
  const { models: { me: { isLoggedIn, gender: myGender } } } = state

  const gender = isLoggedIn ? myGender : (userGenderCookie || myGender)

  // @ts-ignore
  return gender === 'male' ? links.subscription.mainMen : links.subscription.mainWomen
}
